// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const terapagos: PokeData = {
  "id": 1024,
  "name": "terapagos",
  "height": 2,
  "weight": 65,
  "base_experience": 90,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "headbutt",
    "double-edge",
    "withdraw",
    "tri-attack",
    "protect",
    "rapid-spin",
    "ancient-power",
    "gyro-ball",
    "rock-polish",
    "earth-power",
    "heavy-slam",
    "tera-starstorm"
  ],
  "moves": [
    "headbutt",
    "tri-attack",
    "protect",
    "ancient-power",
    "earth-power",
    "tackle",
    "leer",
    "refresh",
    "body-slam",
    "growl",
    "supersonic",
    "splash",
    "quick-attack"
  ],
  "evolution_chain": {
    "id": 548,
    "item": null,
    "species": [
      {
        "name": "terapagos",
        "order": 1026,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 165,
    "speed": 113,
    "ability_power": 122
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
